__turbopack_context__.v({
  "bodyWrapper": "qipueq_bodyWrapper",
  "divider": "qipueq_divider",
  "vertical": "qipueq_vertical",
  "wrapper": "qipueq_wrapper",
});
